import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTabsGroup = styled.div`
  background-color: inherit;
  box-sizing: border-box;
  display: flex;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndex.tabsGroup.value};
`;

const TabsGroup = React.forwardRef(({ label, ...other }, ref) => (
  <StyledTabsGroup aria-label={label} ref={ref} {...other} />
));

TabsGroup.propTypes = {
  /** Provides a label that describes the purpose of the set of tabs */
  label: PropTypes.node.isRequired,
};

export { TabsGroup };
